import Vue from 'vue';
import { mapGetters } from 'vuex';
import _ from 'lodash';
import { cssGenerator } from '@/mixins/css-generator';
import tooltip from '@/mixins/components/tooltip';
import { SQUASH_DROPLET } from '@/constants';
import DropletOptions from '../_bubble-options';
import AudioSeriesOptions from './components/_edit-options';
import schema from './droplet.schema';
const dropletSchema = schema();

export default Vue.component('audio-series', {
  template: require('./template.html'),
  mixins: [cssGenerator],
  computed: {
    ...mapGetters([
      'currentPage',
      'viewport',
      'localStyle',
      'activeDroplet',
      'activeState',
      'animationPreview',
      'dropletObserver',
      'dragging',
      'globalBubbleOptionsOpen',
    ]),
    roamingTemplate() {
      return this.currentPage.type !== 'template' && this.droplet.templateRegion;
    },
    profile() {
      return this._dropletType(this.droplet);
    },
    hideTransform() {
      return this.dragging || this.globalBubbleOptionsOpen;
    },
    isActiveDroplet() {
      return this.activeDroplet._id === this.droplet._id;
    },
    displayStatus() {
      let settings = {
        desktop: 'default',
        tablet: 'default',
        mobile: 'default',
      };
      const selector = _.find(this.droplet.mediaQueries, { selector: ', .drzAudio, .drzAudio-episodes-container' });
      if (selector) {
        const property = _.find(selector.properties, { property: 'display' });
        if (property) {
          settings = property;
        }
      }
      return settings;
    },
    getEpisodesJSON() {
      // we need this only for editor purposes as we need to alter the source
      // paths a bit
      const list = _.cloneDeep(this.droplet.episodes).map((episode) => {
        episode.source = `${this._servePrefix(episode.source)}${episode.source}`;
        episode.title = episode.title || '';
        return episode;
      });
      return JSON.stringify({ list });
    },
    firstEpisode() {
      let source = '';
      let title = 'Title Here';
      const episodes = this.droplet.episodes;
      if (episodes.length > 0) {
        source = `${this._servePrefix(episodes[0].source)}${episodes[0].source}`;
        title = episodes[0].title || '';
      }
      return { source, title };
    },
  },
  data() {
    return {
      type: dropletSchema.type,
      SQUASH_DROPLET,
      display: {
        perspective: null,
        top: null,
        left: null,
        right: null,
        bottom: null,
        ctPaddingTop: null,
        ctPaddingBottom: null,
        ctPaddingLeft: null,
        ctPaddingRight: null,
        transform: null,
        'box-shadow': null,
        'letter-spacing': null,
      },
      hidden: false,
      dropletHovered: false,
      showEditBubble: false,
      setBubbleSize: 'dropletBubble-normal',
      showRevealClass: false,
    };
  },
  components: {
    DropletOptions,
    AudioSeriesOptions,
    tooltip,
  },
  name: 'audio-series',
  props: ['droplet', 'items', 'index'],
  watch: {
    isActiveDroplet(is) {
      if (is) {
        this._scrollToDroplet(this.$el);
      }
    },
    activeState(state) {
      if (state === ':reveal' && this.isActiveDroplet) {
        this.showRevealClass = true;
      } else {
        this.showRevealClass = false;
      }
    },
    'activeDroplet._id': function c(id) {
      if (!id) {
        this.showRevealClass = false;
      }
    },
    animationPreview(should) {
      if (should && this.isActiveDroplet) {
        const droplet = this.$refs.dropletRow;
        const $droplet = $(droplet);
        $droplet.drzOnReveal({
          editing: this.isActiveDroplet,
          child: '.drzAudio',
        });
      }
    },
    viewport() {
      this.callCssGenerator();
      this.observeVisibility();
    },
    'localStyle.value': function setLocals() {
      this.setDisplay();
    },
    dropletObserver(id) {
      if (this.droplet._id === id) {
        this.observeVisibility();
        this.$store.dispatch('setDropletObserver', false);
      }
    },
    'droplet.episodes': {
      deep: true,
      handler() {
        setTimeout(() => {
          this.buildEpisodeJSON();
          this.unBindPlugin();
          this.bindPlugin();
        }, 300);
      },
    },
  },
  mounted() {
    this.callCssGenerator();
    $(document).ready(this.bindPlugin);
    this.observeVisibility();
  },
  methods: {
    callCssGenerator() {
      return this.generateCSS({
        drp: this.droplet,
      });
    },
    observeVisibility() {
      const display = this.displayStatus;
      if (display[this.viewport] === 'none' || (display[this.viewport] === 'default' && display.desktop === 'none')) {
        this.hidden = true;
      } else {
        this.hidden = false;
      }
    },
    buildEpisodeJSON() {
      const list = _.cloneDeep(this.droplet.episodes).map((episode) => {
        episode.title = episode.title || '';
        return episode;
      });
      this.$store.dispatch('setDropletVal', {
        drp: this.droplet,
        key: 'episodesJSON',
        val: JSON.stringify({ list }),
      });
    },
    setDisplay() {
      if (this.activeDroplet._id === this.droplet._id) {
        const styles = this.localStyle;
        if (styles.properties.length > 0) {
          _.forEach(styles.properties, (property) => {
            this.$set(this.display, property, styles.value);
          });
        } else {
          _.forOwn(this.display, (value, key) => {
            this.display[key] = null;
          });
        }
      }
    },
    bindPlugin() {
      const $player = $(this.$refs.drzAudio);
      $player.drzAudioPlayer();
    },
    unBindPlugin() {
      const ref = this.$refs.drzAudio;
      const $player = $(ref);
      if (ref) {
        $player.drzAudioPlayer.destroy($player);
      }
    },
    toggleBubble() {
      if (!this.roamingTemplate) {
        this.showEditBubble = !this.showEditBubble;
      }
    },
  },
});



// WEBPACK FOOTER //
// ./src/global-view/editor/droplets/audio-series/index.js